// ============================================================
// STATE PATCH (plan state-field-merge, 2026-10-24): what a screen changed
// in a combatant's state since the copy it last held - the keys whose
// value differs (by value: canonical JSON, never key order), the keys it
// no longer has, and always the clock. Sent instead of the whole state,
// so two seats changing different fields of one combatant at once both
// land (a list is one field: it is sent whole).
//
// Pure. Zero React dependency.
// ============================================================
import { canonicalJson } from '../canonicalJson';

/** The keys to set and to remove: the shape the backend's `mergeFields` takes. */
export interface StatePatch {
  set: Record<string, unknown>;
  del: string[];
}

export function statePatch(
  base: Readonly<Record<string, unknown>>,
  now: Readonly<Record<string, unknown>>,
): StatePatch {
  const set: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(now)) {
    if (key === 'rev' || canonicalJson(value) !== canonicalJson(base[key])) set[key] = value;
  }
  const del = Object.keys(base).filter((key) => key !== 'rev' && !(key in now));
  return { set, del };
}

/** Two patches of one combatant as one (two edits inside one debounce): the later value of a key wins. */
export function combinePatches(first: StatePatch, then: StatePatch): StatePatch {
  const set: Record<string, unknown> = { ...first.set, ...then.set };
  for (const key of then.del) delete set[key];
  const del = [...new Set([...first.del, ...then.del])].filter((key) => !(key in then.set));
  return { set, del };
}
